/**
 * Event delegation module.
 *
 * Replaces inline onclick= handlers with delegated event listeners using data-* attributes.
 * Each handler checks for a specific data attribute and calls the corresponding global function.
 */
/* global openAdvanceSearchModal */
export function initEventDelegation() {
    // Event delegation handler for data-action-open-search-modal
    $(document).on('click', '[data-action-open-search-modal]', function () {
        let ajaxLoad = $(this).data('ajax-load') || false;
        let searchHash = $(this).data('search-hash') || '';
        openAdvanceSearchModal(ajaxLoad, searchHash);
    });

    // data-action-open-new-window="url" (optional: data-window-width, data-window-height, data-window-title, data-window-left, data-window-top, data-window-new)
    $(document).on('click', '[data-action-open-new-window]', function (e) {
        e.preventDefault();
        let url = $(this).data('action-open-new-window');
        let width = $(this).data('window-width') || $(document).width();
        let height = $(this).data('window-height') || $(document).height();
        let title = $(this).data('window-title') || '';
        let left = $(this).data('window-left') || '';
        let top = $(this).data('window-top') || '';
        let isNewWindow = $(this).data('window-new') || '';
        commonUtils.openNewWindow(url, width, height, title, left, top, isNewWindow);
    });

    // data-action-share-event="event_name"
    $(document).on('click', '[data-action-share-event]', function () {
        commonUtils.dataLayer.shareButtonDataLayerEvent($(this).data('action-share-event'));
    });

    // data-action-datalayer-event="event_name"
    $(document).on('click', '[data-action-datalayer-event]', function () {
        commonUtils.dataLayer.genericDataLayerEvent($(this).data('action-datalayer-event'));
    });

    // data-action-call-lead-event="action" data-call-lead-location="location"
    $(document).on('click', '[data-action-call-lead-event]', function () {
        commonUtils.dataLayer.vifPageCallLeadDataLayerEvent(
            $(this).data('action-call-lead-event'),
            $(this).data('call-lead-location')
        );
    });

    // data-action-pageview-event="page" data-pageview-location="location"
    $(document).on('click', '[data-action-pageview-event]', function () {
        commonUtils.dataLayer.genericPageViewDataLayerEvent(
            $(this).data('action-pageview-event'),
            $(this).data('pageview-location')
        );
    });

    // data-action-bonus-logo-counter="adId"
    $(document).on('click', '[data-action-bonus-logo-counter]', function () {
        commonUtils.bonusLogoCounter($(this).data('action-bonus-logo-counter'));
    });

    // data-action-redirect-clean-url="type" data-redirect-slug="slug"
    $(document).on('click', '[data-action-redirect-clean-url]', function () {
        commonUtils.redirectToCleanUrl($(this).data('action-redirect-clean-url'), $(this).data('redirect-slug'));
    });

    // data-action-set-cookie="name" data-cookie-value="value" data-cookie-days="days"
    // optional: data-redirect-after-cookie="url", data-dismiss-tooltip
    $(document).on('click', '[data-action-set-cookie]', function (e) {
        commonUtils.setCookie(
            $(this).data('action-set-cookie'),
            $(this).data('cookie-value'),
            $(this).data('cookie-days')
        );
        let redirectUrl = $(this).data('redirect-after-cookie');
        if (redirectUrl) {
            e.preventDefault();
            window.location.replace(redirectUrl);
        }
        if ($(this).data('dismiss-tooltip') !== undefined) {
            $(this).parent().parent().hide();
        }
    });

    // data-action-start-dealer-chat data-ad-id="id" data-provider-id="id" data-chat-provider='json'
    $(document).on('click', '[data-action-start-dealer-chat]', function () {
        commonUtils.startDealerChat($(this).data('ad-id'), $(this).data('provider-id'), $(this).data('chat-provider'));
    });

    // data-action-show-hide-toggle="selector"
    $(document).on('click', '[data-action-show-hide-toggle]', function () {
        commonUtils.showHideToggle($(this).data('action-show-hide-toggle'));
    });

    // data-action-scroll-top
    $(document).on('click', '[data-action-scroll-top]', function (e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, 'slow');
    });

    // data-action-history-back
    $(document).on('click', '[data-action-history-back]', function (e) {
        e.preventDefault();
        history.back();
    });

    // data-action-print-page
    $(document).on('click', '[data-action-print-page]', function (e) {
        e.preventDefault();
        window.print();
    });

    // data-action-colorbox-close
    $(document).on('click', '[data-action-colorbox-close]', function () {
        $.colorbox.close();
    });

    // data-action-colorbox-inline="selector" (optional: data-colorbox-scrolling, data-colorbox-transition)
    $(document).on('click', '[data-action-colorbox-inline]', function (e) {
        e.preventDefault();
        let href = $(this).data('action-colorbox-inline');
        let transition = $(this).data('colorbox-transition') || 'none';
        let options = {
            href,
            inline: true,
            initialWidth: commonUtils.getColorBoxResponsiveWidth(),
            transition,
            reposition: true,
        };
        if ($(this).data('colorbox-scrolling')) {
            options.scrolling = true;
        }
        $.colorbox(options);
    });

    // data-action-colorbox-href (opens colorbox with the element's href attribute)
    $(document).on('click', '[data-action-colorbox-href]', function (e) {
        e.preventDefault();
        $.colorbox({ href: $(this).attr('href') });
        return false;
    });

    // data-action-window-open="url" (simple window.open)
    $(document).on('click', '[data-action-window-open]', function () {
        window.open($(this).data('action-window-open'));
    });

    // data-action-redirect="url" (window.location.href redirect)
    $(document).on('click', '[data-action-redirect]', function (e) {
        e.preventDefault();
        window.location.href = $(this).data('action-redirect');
    });

    // data-action-close-window (self.close())
    $(document).on('click', '[data-action-close-window]', function (e) {
        e.preventDefault();
        self.close();
    });

    // data-action-add-class="className" data-add-class-target="selector"
    $(document).on('click', '[data-action-add-class]', function () {
        $($(this).data('add-class-target')).addClass($(this).data('action-add-class'));
    });

    // data-action-toggle-element="selector"
    $(document).on('click', '[data-action-toggle-element]', function () {
        $($(this).data('action-toggle-element')).toggle();
    });

    // data-action-seo-text-expand="targetSelector" (reads seo-text from next sibling)
    $(document).on('click', '[data-action-seo-text-expand]', function () {
        $($(this).data('action-seo-text-expand')).html($(this).next().data('seo-text'));
    });

    // data-action-show-next (hides this element, shows next sibling)
    $(document).on('click', '[data-action-show-next]', function () {
        $(this).hide().next().show();
    });

    // data-action-show-element="selector" (optional: data-show-display="flex")
    $(document).on('click', '[data-action-show-element]', function () {
        let display = $(this).data('show-display') || 'block';
        $($(this).data('action-show-element')).css('display', display);
    });

    // data-action-trigger-click="selector"
    $(document).on('click', '[data-action-trigger-click]', function () {
        $($(this).data('action-trigger-click')).click();
    });

    // data-action-submit-form="formId" (optional: data-set-field-target="selector" data-action-set-field-value="value")
    $(document).on('click', '[data-action-submit-form]', function (e) {
        e.preventDefault();
        let fieldTarget = $(this).data('set-field-target');
        let fieldValue = $(this).data('action-set-field-value');
        if (fieldTarget) {
            $(fieldTarget).val(fieldValue);
        }
        $(`#${$(this).data('action-submit-form')}`).submit();
    });

    // data-action-set-field-value="value" data-set-field-target="selector" (sets field value without submitting)
    $(document).on('click', '[data-action-set-field-value]:not([data-action-submit-form])', function () {
        $($(this).data('set-field-target')).val($(this).data('action-set-field-value'));
    });

    // data-action-show-and-resize-colorbox="selector" (shows target element and resizes colorbox)
    $(document).on('click', '[data-action-show-and-resize-colorbox]', function () {
        $($(this).data('action-show-and-resize-colorbox')).show();
        $.colorbox.resize({ width: $('#colorbox').width() });
    });

    // data-action-redirect-clean-url-select="type" (onChange for <select> elements)
    $(document).on('change', '[data-action-redirect-clean-url-select]', function () {
        commonUtils.redirectToCleanUrl(
            $(this).data('action-redirect-clean-url-select'),
            $('option:selected', this).text()
        );
    });

    // data-action-blur-on-enter (blur input when Enter key is pressed)
    $(document).on('keydown', '[data-action-blur-on-enter]', function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            $(this).blur();
        }
    });

    // data-action-sketch-action="continue|delete"
    $(document).on('click', '[data-action-sketch-action]', function () {
        let action = $(this).data('action-sketch-action');
        if (action === 'continue') {
            commonUtils.continueSketchAd();
        } else if (action === 'delete') {
            commonUtils.deleteSketchAdData();
        }
    });

    // Event delegation handler for data-action-colorbox-favourite-info
    $(document).on('click', '[data-action-colorbox-favourite-info]', function (e) {
        e.preventDefault();
        let notificationSelector = $(this).data('colorbox-hide-on-load');
        $.colorbox({
            href: $(this).attr('href'),
            onLoad() {
                $('html').css({ overflow: '' });
                if (notificationSelector) {
                    $(notificationSelector).hide();
                }
            },
        });
        return false;
    });
}
